import { Divider, Stack, Typography } from '@mui/material';
import type { Viewer } from '@repo/api-gw-sdk';

import { TextLink } from '@/components/shared/textLink';
import { useUser } from '@/contexts/useUser';

export const isEulaAcceptanceRequired = (
  user: Viewer | undefined,
  isEmployee: boolean
) => {
  const isNonMarketplaceAccount =
    user &&
    !user.eonAccount.awsSubscriptionId &&
    !user.eonAccount.azureSubscriptionId &&
    !user.eonAccount.gcpSubscriptionId;

  if (!isNonMarketplaceAccount || isEmployee) {
    return false;
  }

  return !user.eonAccount.msaAcceptance?.signedByEmail;
};

export const Eula = () => {
  const { user, isEmployee } = useUser();
  const showEulaStatement = isEulaAcceptanceRequired(user, isEmployee);
  if (!showEulaStatement) {
    return null;
  }

  return (
    <>
      <Divider sx={{ borderStyle: 'dashed', marginY: '20px' }} />
      <Stack direction='row' alignItems='center'>
        <Typography variant='body2'>By continuing, you agree to the</Typography>
        <TextLink
          prefetch={false}
          href='https://d7umqicpi7263.cloudfront.net/eula/2v-vrAMCiwQ7f74aoYiZsngF4AZKLdQYcxDOv4JTeUg'
          target='_blank'
          className='text-[var(--mui-palette-text-secondary)] hover:text-[var(--mui-palette-text-primary)] ml-[4px]'
        >
          Eon Terms of Service
        </TextLink>
        <Typography variant='body2'>.</Typography>
      </Stack>
    </>
  );
};
